




































































































































import Vue from "vue";
import * as types from "../store/types";
import { mapGetters, mapActions } from "vuex";

type StepDef = {
  stepNum: number;
  title: string;
  component: string;
};

export default Vue.extend({
  name: "ApplicationPage",

  metaInfo() {
    return {
      title: "Application | ARPA Small Business - Greene County, MO",
    };
  },

  data() {
    return {
      loading: false,
      showIncompleteDialog: false,
      expandedStep: 0,
      completedSteps: [-1],
      stepDefinitions: [
        {
          stepNum: 0,
          title: "Qualifying Criteria",
          component: "application-step1",
        },
        {
          stepNum: 1,
          title: "Grant Calculator",
          component: "application-step2",
        },
        {
          stepNum: 2,
          title: "General/Contact Information",
          component: "application-step3",
        },
        {
          stepNum: 3,
          title: "Demographic Information",
          component: "application-step4",
        },
        {
          stepNum: 4,
          title: "Application Overview",
          component: "application-step5",
        },
        {
          stepNum: 5,
          title: "Supporting Documentation",
          component: "application-step6",
        },
        {
          stepNum: 6,
          title: "Confirmation",
          component: "application-step7",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      loadApplication: types.LOAD_APPLICATION,
      saveStep: types.SAVE_FORM_STEP,
      submit: types.SUBMIT_APPLICATION,
    }),
    switchToStep(stepNum: number, disableAutoscroll = false) {
      if (this.expandedStep == stepNum) return;

      this.expandedStep = stepNum;
      setTimeout(() => {
        // eslint-disable-next-line
        const stepRef = this.$refs["step" + stepNum] as any;
        if (!stepRef || !stepRef[0]) return;

        if (!disableAutoscroll)
          this.$smoothScroll({
            scrollTo: stepRef[0].$el,
          });
      }, 300);
    },
    submitAll() {
      if (this.incompleteSteps.length > 0) {
        return (this.showIncompleteDialog = true);
      }

      this.submit();
    },
    nextStep() {
      const nextStepNum = this.expandedStep + 1;
      if (this.currentStep < nextStepNum)
        this.saveStep({
          newCurStepNum: nextStepNum, // next step
        });

      this.switchToStep(nextStepNum);
    },
    updateValidity(stepNum: number, isValid: boolean) {
      if (isValid) this.completedSteps.push(stepNum);
      else
        this.completedSteps = this.completedSteps.filter(
          (num) => num != stepNum
        );
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      status: types.CURRENT_STATUS,
      currentStep: types.CURRENT_STEP,
      stepSaving: types.SAVING_FORM,
      submitted: types.APPLICATION_SUBMITTED,
      application: types.APPLICATION,
    }),
    incompleteSteps(): StepDef[] {
      return this.stepDefinitions
        .filter((step) => step.stepNum !== 6)
        .filter((step) => !this.completedSteps.includes(step.stepNum));
    },
    readOnlyMode() {
      return this.submitted && this.status != "Response Required";
    },
    applicationIs2022() {
      return this.application?.createdAt.date.indexOf("2022") === 0;
    },
  },

  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.loading = true;
        this.loadApplication({ applicationId: this.$route.params.id }).then(
          () => {
            this.loading = false;
            setTimeout(
              () => this.switchToStep(this.currentStep, this.submitted),
              500
            );
          }
        );
      },
    },
    stepSaving: {
      handler() {
        const savingCompleted = !this.stepSaving;
        if (savingCompleted) {
          if (this.submitted)
            setTimeout(
              () =>
                this.$smoothScroll({
                  scrollTo: this.$el,
                }),
              600
            );
        }
      },
      immediate: true,
    },
  },
});
